var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthBgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1194,
    height: 1249,
    viewBox: "0 0 1194 1249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M418.318 502.793C360.404 538.989 244.574 633.101 244.574 741.691C244.574 850.281 461.754 1002.31 635.498 1002.31C852.678 1002.31 917.832 785.127 917.832 676.537C917.832 611.383 896.114 307.331 570.344 263.895C353.164 263.895 418.318 589.665 440.036 633.101C461.754 676.537 505.19 806.845 635.498 828.563C765.806 850.281 767.102 492.581 657.216 437.639C613.78 415.921 468.994 452.117 418.318 502.793Z",
    stroke: "#F2F8F8",
    strokeWidth: 48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1048.16 980.592C1256.65 719.976 1149.51 394.206 1069.88 263.898C961.289 111.872 896.453 52.2854 635.518 25C70.8503 46.718 6.01477 616.954 27.4143 785.13C47.3067 941.463 136.004 1067.46 288.03 1154.34C440.056 1241.21 787.545 1306.36 1048.16 980.592Z",
    stroke: "#F2F8F8",
    strokeWidth: 48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBgLogo);
export default __webpack_public_path__ + "static/media/auth_bg_logo.9703660711c8dd724066a66833fdc23f.svg";
export { ForwardRef as ReactComponent };